import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import MusicsPageComponent from '../components/MusicsPageComponent';
import { getMusicDataIfNeeded, getFilteredMusicDataIfNeeded } from '../actions/MusicsPageActions';

const mapStateToProps = (state) => ({
    musicsPageData: state.musics.musicsPage.musicsPageData,
    filteredMusics: state.musics.musicsPage.filteredMusics,
    isLoading: state.musics.musicsPage.isLoading,
    noMoreMusics: state.musics.musicsPage.noMoreMusics,
    noMoreFilteredMusics: state.musics.musicsPage.noMoreFilteredMusics,
});
const mapDispatchToProps = (dispatch) => ({
    getMusicDataIfNeeded: (num, init) => {
        dispatch(getMusicDataIfNeeded(num, init));
    },
    getFilteredMusicDataIfNeeded: (num, init, options) => {
        dispatch(getFilteredMusicDataIfNeeded(num, init, options));
    },
});
const MusicsPageContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(MusicsPageComponent);

export default withRouter(MusicsPageContainer);
